import { Slot } from '@radix-ui/react-slot'

import { cn } from '@/lib/utils'

import type { ButtonHTMLAttributes, Ref } from 'react'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  asChild?: boolean
  ref?: Ref<HTMLButtonElement>
}

/**
 * Button primitive
 *
 * React 19 pattern: Direct ref prop (no forwardRef needed)
 */
export function Button({
  className,
  asChild = false,
  ref,
  ...props
}: ButtonProps) {
  const Comp = asChild ? Slot : 'button'

  return (
    <Comp
      className={cn(
        'inline-flex items-center justify-center whitespace-nowrap focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
        className
      )}
      ref={ref}
      {...props}
    />
  )
}

Button.displayName = 'Button'
